import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserInfoBuilder,
  addDailyCreditsBuilder,
  sendCodeBuilder,
  verifyEmailBuilder,
  generateCollectionBuilder,
  setUsernameBuilder,
  deleteAccountBuilder,
  getReferralUsersBuilder,
  updateTrainModelBuilder,
  toggleToFavoriteBuilder,
  regenerateCollectionBuilder,
  refreshBuilder,
} from "./builder";
import { LOGOUT } from "../../../utils/constants";

const INIT_STATE = {
  user: null,
  referralEarnings: {
    data: [],
    total: 0,
    perPage: 0,
    page: 0,
    maxReached: false,
  },
  addDailyCreditsPending: false,
  fetchUserInfoPending: false,
  setUsernamePending: false,
  deleteAccountPending: false,
  getReferralUsersPending: true,
};

export const userSlice = createSlice({
  name: "userInfo",
  initialState: INIT_STATE,
  reducers: {
    resetState: () => INIT_STATE,
  },
  extraReducers: (builder) => {
    fetchUserInfoBuilder(builder);
    sendCodeBuilder(builder);
    generateCollectionBuilder(builder);
    regenerateCollectionBuilder(builder);
    verifyEmailBuilder(builder);
    addDailyCreditsBuilder(builder);
    setUsernameBuilder(builder);
    deleteAccountBuilder(builder);
    getReferralUsersBuilder(builder);
    updateTrainModelBuilder(builder);
    toggleToFavoriteBuilder(builder);
    refreshBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE, user: undefined }));
  },
});

export const { resetState } = userSlice.actions;

export const selectUser = (state) => state.userInfo.user;
export const selectAddDailyCreditsLoading = (state) =>
  state.userInfo.addDailyCreditsPending;

export const selectSetUsernamePending = (state) =>
  state.userInfo.setUsernamePending;

export const selectDeleteAccountPending = (state) =>
  state.userInfo.deleteAccountPending;

export const selectGetReferralUsersPending = (state) =>
  state.userInfo.getReferralUsersPending;

export const selectReferralEarnings = (state) =>
  state.userInfo.referralEarnings;

export default userSlice.reducer;
